import { capitalCase } from '@unimpaired/utils'
import { twMerge } from 'tailwind-merge'

// Flat/cheap hover-only placeholder: one wrapper + one badge, no SVG/framer-motion.
export const NewEventPlaceholder = (props: {
  onClick: () => any
  eventDescriptor: string
  className?: string
  placeHolderClasses?: string
}) => (
  <div
    onClick={props.onClick}
    className={twMerge(
      'absolute group flex items-center justify-start px-2 left-2 top-0 right-0 -bottom-px cursor-pointer',
      props.className,
    )}>
    <span
      className={twMerge(
        'flex gap-1 z-200 h-full max-h-8 min-h-6 min-w-fit w-auto truncate text-nowrap pointer-events-none px-2 text-xs rounded items-center border border-primary-300 bg-primary-500 text-white shadow-lg',
        'opacity-0 transition-opacity group-hover:opacity-100',
        props.placeHolderClasses,
      )}>
      + New {capitalCase(props.eventDescriptor)}
    </span>
  </div>
)
